module.exports = __webpack_public_path__ + "static/media/tw.601d8245.svg";